export class TransactionDescriptionBuilder {
  private parts: string[] = [];

  constructor(private baseName: string) {
    if (!baseName) {
      throw new Error('Transaction rule name is required');
    }
    this.parts.push(`${baseName}:`);
  }

  addCashFlow(direction?: 'incoming' | 'outgoing', partyName?: string, country?: string): TransactionDescriptionBuilder {
    if (partyName || country) {
      const directionText = direction && partyName ? (direction === 'incoming' ? 'from' : 'to') : '';
      const partyText = partyName ? `${directionText} ${partyName}` : '';
      const countryText = country ? `in ${country}` : '';

      const partyPart = [partyText, countryText].filter(Boolean).join(' ');
      if (partyPart) {
        this.parts.push(partyPart);
      }
    }
    return this;
  }

  addAmountRange(from?: number | string | null, to?: number | string | null): TransactionDescriptionBuilder {
    const fromValue = from !== undefined && from !== null ? String(from).trim() : '';
    const toValue = to !== undefined && to !== null ? String(to).trim() : '';

    if (fromValue && toValue) {
      this.parts.push(`Between ${fromValue} and ${toValue}`);
    }
    return this;
  }

  addMaxAmount(amount?: number | string | null, period?: string | null): TransactionDescriptionBuilder {
    const amountValue = amount !== undefined && amount !== null ? String(amount).trim() : '';
    const periodValue = period !== undefined && period !== null ? String(period).trim() : '';

    if (amountValue && periodValue) {
      this.parts.push(`with a max of ${amountValue} per ${periodValue}`);
    }
    return this;
  }

  addFrequency(count?: number | string | null, period?: string | null): TransactionDescriptionBuilder {
    const countValue = count !== undefined && count !== null ? String(count).trim() : '';
    const periodValue = period !== undefined && period !== null ? String(period).trim() : '';

    if (countValue && periodValue) {
      this.parts.push(`and a frequency of ${countValue} per ${periodValue}`);
    }
    return this;
  }

  build(): string {
    return this.parts.join(' ');
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/transaction-rule/transaction-rule-descriptionn-builder.ts